import { eventsApi } from '../../object-plus/index.js';
import { ItemsBehavior, transactionApi } from '../../transactions.js';
import { AnyType } from './any.js';
const { on, off } = eventsApi, { free, aquire } = transactionApi;
const shareAndListen = ItemsBehavior.listen | ItemsBehavior.share;
export class SharedType extends AnyType {
    doInit(value, record, options) {
        const v = options.clone ? this.clone(value, record) : (value === void 0 ? this.defaultValue() : value);
        const x = this.transform(v, void 0, record, options);
        this.handleChange(x, void 0, record, options);
        return x;
    }
    doUpdate(value, record, options, nested) {
        const key = this.name, { attributes } = record;
        const prev = attributes[key];
        let update;
        if (update = this.canBeUpdated(prev, value, options)) {
            const nestedTransaction = prev._createTransaction(update, options);
            if (nestedTransaction) {
                if (nested) {
                    nested.push(nestedTransaction);
                }
                else {
                    nestedTransaction.commit(record);
                }
                if (this.propagateChanges)
                    return true;
            }
            return false;
        }
        const next = this.transform(value, prev, record, options);
        attributes[key] = next;
        if (this.isChanged(next, prev)) {
            this.handleChange(next, prev, record, options);
            return true;
        }
        return false;
    }
    clone(value, record) {
        if (!value || value._owner !== record)
            return value;
        const clone = value.clone();
        aquire(record, clone, this.name);
        return clone;
    }
    toJSON() { }
    canBeUpdated(prev, next, options) {
        if (prev && next != null && !(next instanceof this.type)) {
            return next;
        }
    }
    convert(next, prev, record, options) {
        if (next == null || next instanceof this.type)
            return next;
        const implicitObject = new this.type(next, options, shareAndListen);
        aquire(record, implicitObject, this.name);
        return implicitObject;
    }
    validate(model, value, name) { }
    create() {
        return null;
    }
    _handleChange(next, prev, record, options) {
        if (prev) {
            if (prev._owner === record) {
                free(record, prev);
                options.unset || prev.dispose();
            }
            else {
                off(prev, prev._changeEventName, this._onChange, record);
            }
        }
        if (next) {
            if (next._owner !== record) {
                on(next, next._changeEventName, this._onChange, record);
            }
        }
    }
    dispose(record, value) {
        if (value) {
            this.handleChange(void 0, value, record, {});
        }
    }
    initialize(options) {
        const attribute = this;
        this._onChange = this.propagateChanges ? function (child, options, initiator) {
            this === initiator || this.forceAttributeChange(attribute.name, options);
        } : ignore;
        options.changeHandlers.unshift(this._handleChange);
    }
}
function ignore() { }
//# sourceMappingURL=shared.js.map